
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clients",
      function () {
        return require("private-next-pages/clients.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clients"])
      });
    }
  